// import { TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { createPendingPayFromPaymentRequestOnSisad, getPendingPaymentRequestsFromSisad } from '../../../redux/api/account'
import PageLoading from '../../common/PageLoading'
// import { Autocomplete } from '@material-ui/lab';
import TableGeneric from '../../common/TableGeneric'
import { ButtonBlue, ButtonGreen, ButtonRed } from '../../common/ButtonsGenerics'
import { formatCurrency } from '../../../helpers/currency.format.helper'
import { ButtonTransparent } from "../../../components/common/ButtonsGenerics";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';



const PendingList = (props) => {

    const { user: afiliado_id, handlePagePay, gotoPage } = props

    const columns = [
        { id: 'afiliado', label: 'Nombre' },
        { id: 'name', label: 'Descripción' },
        { id: 'fecha', label: 'Fecha' },
        { id: 'total', label: 'Monto' },
        { id: 'acciones', label: 'Acciones' },
    ]

    const [pays, setPays] = useState(null)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        !pays && getPays()
    }, [pays])

    const getPays = async () => {
        const req = await getPendingPaymentRequestsFromSisad(afiliado_id)
        if (req.error) {
            if (req.error.message.includes('404')) {
                alert('El dni ingresado no es válido')
            }else{
                alert('Ha ocurrido un error')
            }
            setPays([])
            gotoPage(0)
            return;
        }
        
        setPays(req)
    }

    const handleSelect = value => {
        const result = pays.map(item => {
            if (item.id === value.id) {
                return { ...item, checked: true }
            }
            else {
                return item
            }
        })
        setTotal(total + value.importeTotal)
        setPays(result)
    }

    const handleQuit = value => {
        const result = pays.map(item => {
            if (item.id === value.id) {
                return { ...item, checked: false }
            }
            else {
                return item
            }
        })
        setTotal(total - value.importeTotal)
        setPays(result)
    }


    const tableRender = (array) => {
        if (array) {
            return array.map(item => ({
                ...item,
                afiliado: item.nombreApellido,
                name: item.detalle,
                fecha: new Date(item.fecha).toLocaleDateString(),
                total: `$${formatCurrency(item.importeTotal.toFixed(2))}`,
                acciones: !!item.checked ? <ButtonRed onClick={() => handleQuit(item)}>Quitar</ButtonRed> : <ButtonGreen onClick={() => handleSelect(item)}>Seleccionar</ButtonGreen>
            }))
        }
        else {
            return array
        }
    }

    const handleSubmitPagoTarjeta = async () => {
        setLoading(true)
        const body = { pagoSolicitudArr: pays.filter(item => !!item.checked).map(item => item.id) }
        body.dni = afiliado_id;
        const req = await createPendingPayFromPaymentRequestOnSisad(body)
        setLoading(false)
        if (req.error) {
            alert('Ocurió un error al generar el pago')
            return
        }
        else {
            handlePagePay(req.amount_total.toFixed(2), req.id, 'credit-card')
        }
    }


    const handleSubmitPagoBilletera = async ()=>{
        setLoading(true)
        const body = { pagoSolicitudArr: pays.filter(item => !!item.checked).map(item => item.id) }
        body.dni = afiliado_id;
        const req = await createPendingPayFromPaymentRequestOnSisad(body)
        setLoading(false)
        if (req.error) {
            alert('Ocurió un error al generar el pago')
            return
        }
        else {
            handlePagePay(req.amount_total.toFixed(2), req.id, 'qr-wallet')
        }
    }

    const handleSubmitGenerarReintegro = () => {
        const selectedRequestIds = pays.filter(item => !!item.checked).map(item => item.id)
        handlePagePay(total, null, 'generate-refund', selectedRequestIds)
    }
    
    const handleSubmitPagarConSaldo = () => {
        const selectedRequestIds = pays.filter(item => !!item.checked).map(item => item.id)
        handlePagePay(total, null, 'balance-payment', selectedRequestIds)
     }

    
    if (!pays || loading) {
        return <PageLoading w="100%" h="100px" />
    }
    
    const selectedPaysCount = pays.filter(item => !!item.checked).length
    const hasSelectedPays = selectedPaysCount > 0
    const enablePayments = hasSelectedPays && total > 0
    const enableRefund = hasSelectedPays && total < 0
    const enableBalancePayment = selectedPaysCount > 1 && Number(total.toFixed(2)) === 0
    const totalLabel = total < 0 ? 'Total a reintegrar' : 'Total a pagar'
    const totalToDisplay = total < 0 ? Math.abs(total) : total

    return (
        <PaysWrapper>
            <ArrowBackContainer>
                <ButtonTransparent onClick={() => gotoPage(null)}><ArrowBackIcon /><NameButton>Atras</NameButton></ButtonTransparent>
            </ArrowBackContainer>
            <TableGeneric columns={columns} rows={tableRender(pays)} pageSize={10} />
            <TotalContainer>{totalLabel}: ${formatCurrency(totalToDisplay.toFixed(2))}</TotalContainer>
            <ButtonContainer>
                {enablePayments && <ButtonBlue onClick={handleSubmitPagoBilletera}>Pago con billetera</ButtonBlue>}
                {enablePayments && <ButtonBlue onClick={handleSubmitPagoTarjeta}>Pago con tarjeta</ButtonBlue>}
                {enableRefund && <ButtonBlue onClick={handleSubmitGenerarReintegro}>Generar reintegro</ButtonBlue>}
                {enableBalancePayment && <ButtonBlue onClick={handleSubmitPagarConSaldo}>Pagar con saldo</ButtonBlue>}
            </ButtonContainer>
        </PaysWrapper>
    )
}

export default PendingList

const PaysWrapper = styled.div`
width: 100%;
`

const TotalContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-size: 18px;
    font-weight: bold;
`
const ArrowBackContainer = styled.div`
    width: 100%;
    height: 6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
`
const NameButton = styled.div`
    margin-left: 1rem;
    font-size: 1rem;
`
const ButtonContainer = styled.div`
    margin-top:15px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
`